export const questionMediaExtensions = [
	"jpg",
	"jpeg",
	"png",
	"webp",
	"gif",
	"mp4",
	"webm",
	"mp3",
	"wav",
	"ogg",
	"m4a",
] as const;

export const questionMediaMimeTypes = [
	"image/jpeg",
	"image/png",
	"image/webp",
	"image/gif",
	"video/mp4",
	"video/webm",
	"audio/mpeg",
	"audio/wav",
	"audio/ogg",
	"audio/mp4",
	"audio/x-m4a",
] as const;

export const questionMediaAccept = questionMediaExtensions
	.map((extension) => `.${extension}`)
	.join(",");

export const maxQuestionMediaSize = 30_000_000;

const getExtension = (file: File) =>
	file.name.split(".").pop()?.trim().toLowerCase() ?? "";

const mimeTypesByExtension: Record<string, string> = {
	jpg: "image/jpeg",
	jpeg: "image/jpeg",
	png: "image/png",
	webp: "image/webp",
	gif: "image/gif",
	mp4: "video/mp4",
	webm: "video/webm",
	mp3: "audio/mpeg",
	wav: "audio/wav",
	ogg: "audio/ogg",
	m4a: "audio/mp4",
};

export const getQuestionMediaMimeType = (file: File) =>
	file.type || mimeTypesByExtension[getExtension(file)] || "";

export const isSupportedQuestionMedia = (file: File) =>
	questionMediaMimeTypes.includes(
		file.type.toLowerCase() as (typeof questionMediaMimeTypes)[number],
	) ||
	questionMediaExtensions.includes(
		getExtension(file) as (typeof questionMediaExtensions)[number],
	);

export const validateQuestionMedia = (
	file: File | undefined,
	t: (key: "unsupportedAsset" | "assetTooLarge") => string,
) => {
	if (!file || file.size === 0) return;
	if (!isSupportedQuestionMedia(file)) throw new Error(t("unsupportedAsset"));
	if (file.size > maxQuestionMediaSize) throw new Error(t("assetTooLarge"));
};
